import '../batman/batman-holidays-popup/batman-holidays-popup1.js';
(function () {
  new Batman(`descEasterPromoPopup`, 'holidaysPopup');
})();
